export const getFileType = (filename = '') => {
  const type = filename.split('.');

  return type[type.length - 1].toLowerCase();
};

export const getFileUrl = (filename = '') =>
  `${process.env.REACT_APP_COMMON_API_ENDPOINT}/files/aavs/${filename}`;
